export enum OrganizationStatusType {
  Pending = 1,
  Active = 2,
  Inactive = 3,
  Proposed = 4,
  Approved = 5,
  Rejected = 6,
}
